import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@library-shared/base/base.component';
import { spTicket_List } from '@models/StoredProcs/spTicket_List';
import { TicketService } from '@services/ticket/ticket.service';
import dayjs from 'dayjs';

@Component({
  selector: 'app-ticket-select',
  templateUrl: './ticket-select.component.html',
  styleUrls: ['./ticket-select.component.scss'],
  standalone: false,
})
export class TicketSelectComponent extends BaseComponent implements OnInit, AfterViewInit {
  ticketList: spTicket_List[] = [];
  ticketPayList: spTicket_List[] = [];
  ticketClosedList: spTicket_List[] = [];

  selectedToPayCount = 0;
  selectedToPayTotal = 0;
  totalTicketCount = 0;

  get motoristList(): string {
    const arList = this.ticketList.filter((r) => r.license_number).map((r) => r.license_number + ' ' + r.license_state);

    const seListNoDupe = new Set(arList);
    const arListNoDupe = [...seListNoDupe];
    return arListNoDupe.join(', ');
  }

  get plateList(): string {
    const arList = this.ticketList
      .filter((r) => r.plate_number && !r.license_number)
      .map((r) => r.plate_number + ' ' + r.plate_state);

    const seListNoDupe = new Set(arList);
    const arListNoDupe = [...seListNoDupe];
    return arListNoDupe.join(', ');
  }

  get payableTotal(): number {
    let payable = 0;
    this.ticketPayList
      .filter((r) => !r.is_must_appear && r.ticket_status_code === 'OP')
      .forEach((r) => (payable += r.ticket_balance));
    return payable;
  }

  get ticketsNotShownCount(): number {
    return this.totalTicketCount - this.ticketList.length;
  }

  get ticketListTitle(): string {
    let title = `${this.ticketPayList.length} ticket${
      this.ticketPayList.length > 1 ? 's' : ''
    } found, ${this.canBePaidCount} can be paid, ${
      this.requiresAppearanceCount
    } require${this.requiresAppearanceCount === 1 ? 's' : ''} appearance`;

    if (this.ticketClosedList.length > 0) {
      title += `, ${this.ticketClosedList.length} closed`;
    }
    if (this.ticketsNotShownCount > 0) {
      title += `, ${this.ticketsNotShownCount} not shown`;
    }

    return title;
  }

  get canBePaidCount(): number {
    return this.ticketPayList.filter((r) => !r.is_must_appear && r.ticket_status_code === 'OP').length;
  }

  get requiresAppearanceCount(): number {
    return this.ticketPayList.filter((r) => r.is_must_appear).length;
  }

  get closedCount(): number {
    return this.ticketClosedList.length;
  }

  constructor(
    private ticketService: TicketService,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.loadData();
  }

  ngAfterViewInit() {}

  loadData() {
    this.isLoading2.set(true);
    this.ticketService.Ticket_List().subscribe({
      next: (data) => {
        this.ticketList = data.records.sort((a, b) => {
          if (dayjs(a.offense_datetime).isBefore(b.offense_datetime)) {
            return 1;
          }
          if (dayjs(b.offense_datetime).isBefore(a.offense_datetime)) {
            return -1;
          }
          return 0;
        });
        if (this.ticketList.length == 0) {
          this.router.navigateByUrl('/search');
          return;
        }
        this.ticketPayList = data.records.filter((r) => r.ticket_status_code === 'OP');
        this.ticketClosedList = data.records.filter((r) => r.ticket_status_code !== 'OP');
        this.refreshSelectedToPay();
        const first = this.ticketList.find((r) => true);
        if (first) {
          this.totalTicketCount = first.related_ticket_count;
        } else {
          this.totalTicketCount = 0;
        }
        this.isLoading2.set(false);
      },
    });
  }

  selectAll() {
    this.ticketPayList.forEach((r) => (r.selected_to_pay = true && !r.is_must_appear));
    this.refreshSelectedToPay();
  }

  selectionChanged(e: any) {
    this.refreshSelectedToPay();
  }

  refreshSelectedToPay() {
    let selectedToPayCount = 0;
    let selectedToPayTotal = 0;
    this.ticketList.forEach((r) => {
      if (r.selected_to_pay) {
        selectedToPayCount++;
        selectedToPayTotal += r.ticket_balance;
      }
    });

    this.selectedToPayCount = selectedToPayCount;
    this.selectedToPayTotal = selectedToPayTotal;
  }

  back() {
    this.router.navigateByUrl('/search');
  }

  payTickets() {
    if (this.selectedToPayCount > 0) {
      this.isLoading2.set(true);
      this.ticketService
        .Ticket_Set_Selected_To_Pay({
          ticket_session_list: this.ticketList.filter((r) => r.selected_to_pay).map((r) => r.ticket_session_id),
        })
        .subscribe({
          next: (data) => {
            if (data.success) {
              this.router.navigateByUrl('/affirmation');
            } else {
              this.isLoading2.set(false);
              this.toast_error({ message: data.message });
              this.ticketService.handleFailure(data);
            }
          },
        });
    }
  }
}
